import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const updateUserActiveStatus = async (userId: string, activeStatus: boolean): Promise<AxiosResponse> =>
  AxiosInstance.post('users.setActiveStatus', {
    activeStatus,
    userId,
    confirmRelinquish: true,
  });
